export default "__VITE_ASSET__D49MzRyj__"